// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1Y5KN","title":"Header_title__cjiHu","side":"Header_side__3aCFt"};